const HEADS_FEMININOS = [
  "autorizacao",
  "bandeira",
  "cidade",
  "data",
  "empresa",
  "inscricao",
  "nova",
  "operadora",
  "porta",
  "rua",
  "senha",
  "taxa",
  "unidade",
  "vigencia"
];

const semAcento = (texto: string) => texto.normalize("NFD").replace(/[̀-ͯ]/g, "");

const feminino = (rotulo: string) => {
  const cabeca = semAcento(rotulo.trim().toLowerCase()).split(/[\s/]+/)[0];
  return HEADS_FEMININOS.indexOf(cabeca) > -1;
};

export const campoObrigatorio = (rotulo: string) =>
  `${rotulo} é ${feminino(rotulo) ? "obrigatória" : "obrigatório"}.`;

export default campoObrigatorio;
